import { map } from 'lodash/fp'

const uncappedMap = map.convert({ cap: false })

export const formatSortState = uncappedMap((value, key) => ({
  id: key,
  desc: value === 'desc',
}))

export const normalizeSortState = uncappedMap((value, key) => ({
  column: key,
  asc: value === 'asc',
}))
